import axios from 'axios'
import config from '@/utils/config'

export interface ValidateVoucherReq {
  bookerSurname: string
  voucherCode: string
  checkIn: string
  checkOut: string
  propertyId: number
  currency: string
}

export type ValidateVoucherRes = {
  isValid: false
} | {
  isValid: true
  voucherCode: string
  surname: string
  expiryDate: string
  remainingBalance: number
}

export async function validateVoucher(req: ValidateVoucherReq): Promise<ValidateVoucherRes> {
  return axios.post('/Vouchers/ValidateVoucher', req, { baseURL: config.bookingApi })
    .then(r => r.data)
    .catch(() => ({ isValid: false }))
}
